// utils/openProtectedPdf.util.js
// Abre un documento (presupuesto, propuesta o póliza) a través del gateway, con el token del usuario,
// en lugar del enlace público del bucket.
// - App de Android (wrapper): lo descarga y lo abre el nativo (nativeBridge.openPdf -> bridgeHandler).
// - Web e iPhone (el wrapper de iOS no atiende openPdf): descarga con fetchPdf y abre un blob:.
// Devuelve { ok: true } si se ha podido abrir y { ok: false, status } si no.
import nativeBridge from "./nativeBridge.util";
import { fetchPdf } from "./pdfService.util";

export const isIos = () =>
  typeof navigator !== "undefined" &&
  (/iPhone|iPad|iPod/i.test(navigator.userAgent) ||
    // iPad con iPadOS 13+ se presenta como Mac
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1));

const base64ToBlobUrl = (b64, mime = "application/pdf") => {
  const raw = atob(b64);
  const bytes = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) bytes[i] = raw.charCodeAt(i);
  return URL.createObjectURL(new Blob([bytes], { type: mime }));
};

export async function openProtectedPdf(docType, id) {
  if (!id) return { ok: false };

  // App de Android: lo abre el nativo con el token que recibió por setAuth
  if (nativeBridge.isWrapper() && !isIos()) {
    nativeBridge.openPdf(docType, id);
    return { ok: true };
  }

  // Navegador: la pestaña se abre antes de la petición para que no la bloquee el navegador
  let tab = null;
  if (!nativeBridge.isWrapper() && typeof window !== "undefined") {
    tab = window.open("", "_blank");
  }

  const res = await fetchPdf(docType, id);
  // ms-policy responde 204 (cuerpo vacío) cuando falta el objeto: isPdf llega a false
  if (!res.ok || !res.isPdf || !res.base64) {
    if (tab) tab.close();
    return { ok: false, status: res.status };
  }

  let url;
  try {
    url = base64ToBlobUrl(res.base64);
  } catch (e) {
    if (tab) tab.close();
    return { ok: false };
  }

  if (tab) {
    tab.location.href = url;
  } else {
    // iPhone (wrapper) o navegador que ha bloqueado la pestaña: se abre en la misma ventana
    window.location.assign(url);
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
  return { ok: true };
}

export default openProtectedPdf;
